import * as apis from '@apis'
import Vue from 'vue'
const ClueDig = {
  namespaced: true,
  state: {
    metadata: [],
    regions: []
  },
  getters: {},
  mutations: {
    UPDATE_META_DATA(state, data) {
      if (typeof data === 'object') {
        Object.keys(data).forEach((item) => {
          Vue.set(state.metadata, item, data[item])
        })
      }
    }
  },
  actions: {
    FETCH_REGIONS({ commit }, params) {
      return apis.MediaCloudNewsPlanClueDig.postHotTopicRegions({
        ...params
      }).then((res) => {
        return res.data
      })
    },
    FETCH_TOPICS({ commit }, params) {
      return apis.MediaCloudNewsPlanClueDig.postHotTopicTopics({
        ...params
      }).then((res) => {
        return res.data
      })
    },
    FETCH_META_DATA({ commit }, params) {
      commit('UPDATE_META_DATA', params)
    }
  }
}

export default ClueDig
